import React, { useState } from "react";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { BsCheck, BsCheck2Circle, BsCreditCard2Back, BsWallet2 } from "react-icons/bs";
import { IoCloseSharp } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { Color } from "../../../../Utils/styles";
import { GenderRender, RenderPrice, sepMoney, ToDateJalali } from "../../../Common/Function";
import InSetBoxShadow from "../../../Common/InSetBoxShadow";
import CustomModal from "../../../Common/Modal/CustomModal";
import { useCard } from "../Hooks";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import RulesSite from "../../RulesSite";

const OrderDetails = () => {
  const { changeCount, renderBasketStatus, clearBasket, addPromise, addBall, balance, ntCodeStatus,
    checkOffer, storeReserve, code, setCode, kind, setKind, loading, userInfo, natCodeHandler, checkTrems } = useCard();

  const [showModal, setShowModal] = useState(false)
  const { basket } = useSelector(state => state);
  console.log("basket=>", basket);

  const typePay = [
    {
      label: "آنلاين",
      id: "gateway",
      text: "پرداخت آنلاین",
    },
    {
      label: "کیف پول",
      id: "wallet",
      text: "پرداخت کیف پول",
    },
  ];

  const renderState = () => {
    if (loading.reserve) {
      return "در حال پردازش";
    } else {
      if (kind == "wallet") {
        return "پرداخت با کیف پول";
      }
    }
    return "پرداخت آنلاین";
  };

  const renderStateTime = time => {
    if (time.status == "ok") {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiFillCheckCircle color={Color.greenLight} />
          <h6
            style={{
              fontSize: "12px",
              fontSize: "11px",
              fontWeight: "400",
              marginRight: "5px",
            }}
          >
            آماده رزرو
          </h6>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiFillCloseCircle color={Color.primary} />
          <h6
            style={{
              fontSize: "12px",
              fontSize: "11px",
              fontWeight: "400",
              marginRight: "5px",
            }}
          >
            ظرفیت پر
          </h6>
        </div>
      );
    }
  };


  const renderComponent = () => {
    if (basket.type && basket.type == "contract") {
      return (
        <div className="row" style={{ overflow: "hidden" }}>

          <div className="col-12">

            <div
              className="my-4"
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              {basket.times.map(time => {
                if (time.status == "ok") {
                  return (
                    <div
                      style={{
                        border: "1px solid #eee",
                        borderRadius: "5px",
                        padding: "10px 15px",
                        margin: "0 0 8px 8px",
                      }}
                    >
                      <h6
                        style={{
                          fontWeight: "400",
                          textAlign: "center",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >{`${time.start} تا ${time.end}`}</h6>
                      <h6
                        style={{
                          fontWeight: "400",
                          textAlign: "center",
                          fontSize: "12px",
                          marginTop: "5px",
                          fontWeight: "400",
                        }}
                      >
                        {`${ToDateJalali(time.date)}`}
                      </h6>
                      <h6
                        style={{
                          fontWeight: "400",
                          textAlign: "center",
                          fontSize: "12px",
                          marginTop: "5px",
                          fontWeight: "400",
                        }}
                      >
                        {`${RenderPrice({ price: time.price })}`}
                      </h6>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                          fontWeight: "400",
                        }}
                      >
                        {renderStateTime(time)}
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div className="d-flex align-items-center">

            {basket.time.title && (
              <>
                <div className="">
                  <h6
                    style={{
                      color: "#404040",
                      fontWeight: "400",
                    }}
                  >
                    <img
                      src={window.origin + `/WebSide/assets/images/damble.png`}
                      alt="همه ملاقات"
                      style={{
                        width: "20px",
                        height: "20px",
                        marginLeft: "10px",
                      }}
                    />
                    {basket.time.title}
                  </h6>
                </div>
                <span className="mx-3">-</span>
              </>
            )}

            <h6 style={{
              fontWeight: "400",
              marginTop: "10px"
            }}
            >
              <img
                src={window.origin + `/WebSide/assets/images/404.png`}
                alt="همه ملاقات"
                style={{
                  width: "20px",
                  height: "20px",
                  marginLeft: "8px",
                }}
              />
              {`${basket.time.start} الی ${basket.time.end}`}
            </h6>
            {basket.time.gender && (
              <>
                <span className="mx-3">-</span>
                <div className="dadawdawdawd"
                  style={{
                    color: "#404040",
                    fontWeight: "400",
                  }}
                >
                  <h6
                    className=" h3"
                    style={{
                      color: "#404040",
                      fontWeight: "400",
                    }}
                  >
                    {`ویژه ${GenderRender(basket.time.gender)}`}
                  </h6>

                </div>
              </>
            )}

          </div>
          <div className="row my-3">
            <div className="col mt-3">
              <div className="d-flex align-items-center">
                <p className="me-3 ">
                  تعداد بلیت
                  {
                    basket.timeOption.needchild && basket.timeOption.needchild == "true" &&
                    " بزرگسال"
                  }
                </p>
                <button
                  disabled={!renderBasketStatus("-")}
                  className="counter-btn"
                  style={{ opacity: !renderBasketStatus("-") && " 0.4" }}
                  onClick={() => {
                    changeCount("-");
                  }}
                >
                  -
                </button>
                <div className="count-box">{basket.count}</div>
                <button
                  disabled={!renderBasketStatus("+")}
                  className="counter-btn"
                  onClick={() => {
                    changeCount("+");
                  }}
                >
                  +
                </button>
              </div>
              {
                basket.timeOption.needchild && basket.timeOption.needchild == "true" &&
                <>
                  <div className="d-flex align-items-center mt-3">
                    <p className="me-3 ">تعداد بلیت خردسال</p>

                    <button
                      disabled={!renderBasketStatus("-", true)}
                      className="counter-btn"
                      style={{ opacity: !renderBasketStatus("-", true) && " 0.4" }}
                      onClick={() => {
                        changeCount("-", true);
                      }}
                    >
                      -
                    </button>
                    <div className="count-box">{basket.childcount || 0}</div>
                    <button
                      disabled={!renderBasketStatus("+", true)}
                      className="counter-btn"
                      onClick={() => {
                        changeCount("+", true);
                      }}
                    >
                      +
                    </button>
                  </div>
                  {basket.time.child &&
                    <p style={{ color: "#5a5a5a", fontSize: "14px", fontWeight: "400" }}>{basket.time.child}</p>
                  }
                </>
              }
              {basket.timeOption.needballprice &&
                basket.timeOption.needballprice == "true"
                ? <div className="col-12 my-3">
                  <div className="form-check accept-terms-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultValue
                      id="meddBall"
                      onClick={addBall}
                      checked={basket.reqball}
                    />
                    <label className="form-check-label h3 privacy-item" htmlFor="meddBall" >
                      توپ اجاره‌ای میخواهم
                      ( + {sepMoney(basket.time.ballprice)} هزاتومان )
                    </label>
                  </div>
                </div>
                : <div>
                </div>
                // : <div className="col-12 mt-3">
                //   توپ ندارد
                // </div>
              }
              {
                !basket.timeOption.needballprice && basket.item.categoryName == "سالن ورزشی" &&
                <p className="text-danger mt-3">سالن در قبال ارائه توپ مسئولیتی ندارد</p>
              }
            </div>

          </div>
        </>
      );
    }
  };
  return (
    <>
      <div className="row align-items-stretch">
        <div className="col-lg-8  d-flex flex-column justify-content-between">

          <InSetBoxShadow
            className="py-4 px-3 px-sm-4 px-md-5"
            style={{ borderRadius: "8px" }} >

            <div className="d-flex align-items-center flex-wrap">
              <img
                className="rounded me-3 shadpw-sm"
                style={{ height: "80px" }}
                src={basket.item.image} />

              <h6 className="h3 mb-3 mt-2 mt-sm-3"
                style={{ fontWeight: "400" }} >
                {basket.item.name}
              </h6>
            </div>

            {renderComponent()}

            <div className="d-flex">
              <button className="btn btn-outline-danger mb-2 ms-auto"
                onClick={() => {
                  clearBasket();
                }}
              >
                تغییر اطلاعات بلیت
              </button>

            </div>

            <div className="row mt-md-4">
              {!userInfo?.national_code &&
                <div className="col-12 mb-3">
                  <div className="form-group mb-3 position-relative" style={{ maxWidth: "300px" }}>
                    <label htmlFor="inputPassword4" className="mb-2">
                      <span className="text-danger me-1">*</span>
                      کد ملی
                    </label>
                    <input
                      style={{ ccolor: "#717171" }}
                      type="number"
                      className="form-control pe-4"
                      name="national_code"
                      placeholder="0920000000"
                      onChange={(e) => natCodeHandler(e)}
                      // disabled={(e) => natCodeHandler(e)}
                      maxLength={10}
                    />
                    <span className="position-absolute" style={{ left: "0", top: "38px" }}>
                      {
                        ntCodeStatus
                          ? <BsCheck size={22} className={"text-success"} />
                          : <IoCloseSharp size={22} className={"text-danger"} />
                      }
                    </span>
                  </div>
                </div>
              }

              <div className="col-12 mb-3">
                <div className="form-check accept-terms-checkbox">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue
                    id="flexCheckDefault"
                    onClick={addPromise}
                    checked={basket.promise}
                  />
                  <label className={"form-check-label h3 privacy-item "
                    + (checkTrems && "tremsAnimate")}
                    htmlFor="flexCheckDefault" >
                    با کلیک بر روی این گزینه
                    <span onClick={e => setShowModal(true)}
                      style={{ color: "#E42A3F", display: "inline-flex", marginRight: "3px", marginLeft: "3px" }}>
                      شرایط و قوانین وبسایت
                    </span>
                    ،
                    <span onClick={e => setShowModal(true)}
                      style={{ color: "#E42A3F", display: "inline-flex", marginRight: "3px", marginLeft: "3px" }}>
                      قوانین مجموعه ورزشی
                    </span>
                    و شرایط حریم خصوصی را می‌پذیرم.
                  </label>
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex alert-box">
                  <img
                    src={window.origin + `/WebSide/assets/images/danger.png`}
                    alt="همه ملاقات"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginLeft: "8px",
                    }}
                  />
                  <p
                    style={{
                      color: "#717171",
                    }}
                  >
                    بعد از پرداخت و دریافت بلیت ،{" "}
                    <span style={{ color: "#e42a3f" }}>کدپیگیری</span> برا شما صادر
                    خواهد شد ،‌ لطفا کد را به خاطر بسپارید
                  </p>
                </div>
              </div>
            </div>
          </InSetBoxShadow>
        </div>
        <div className="col-lg-4 my-3 my-lg-0 " style={{ height: "max-content" }}>
          <InSetBoxShadow
            className="py-4 px-3 h-100 red-card d-flex flex-column"
            style={{ borderRadius: "8px" }}
          >
            {
              basket.type && basket.type == "contract"
                ? <>
                  {/* مبلغ قابل پرداخت  */}
                  <div className="d-flex flex-wrap justify-content-between align-items-center text-white mb-3">
                    <h6 className="white-space-nowrap">مبلغ قابل پرداخت : </h6>
                    <h6>
                      {
                        sepMoney(basket.total_price)
                      }
                      <span className="ms-2">تومان</span>
                    </h6>
                  </div>

                </>
                :
                <>
                  {/*  قیمت کل (بدون تخفیف ) --- درصورت بزرگتر بودن قیمت گیشه از فروش*/}
                  {+basket.time.price < +basket.time.boxofficeprice &&
                    <div className="d-flex flex-wrap justify-content-between align-items-center text-white mb-3">
                      <h6 className="white-space-nowrap">قیمت کل : </h6>
                      <h6>
                        {
                          sepMoney(
                            // قیمت گیشه بزرگسال  
                            (basket.time.boxofficeprice * basket.count)
                            +
                            (
                              // قیمت گیشه خردسال در صورت وجود داشتن اعمال میشود
                              basket.timeOption.needchild && basket.timeOption.needchild == "true"
                                ? basket.time.boxofficechildprice * basket.childcount
                                : 0
                            )
                            +
                            // قیمت  توپ
                            (basket?.reqball ? +basket.time.ballprice : 0)
                          )
                        }
                        <span className="ms-2">تومان</span>
                      </h6>
                    </div>
                  }

                  {/* میزان سود کاربر از خرید  -  کسر قیمت فروش از گیشه --- در صورت بزرگتر بودن قیمت گیشه از  فروش  */}
                  {+basket.time.price < +basket.time.boxofficeprice &&
                    <div className="d-flex flex-wrap justify-content-between align-items-center text-white  mb-3">
                      <h6 className="white-space-nowrap">سود شما از خرید : </h6>
                      <h6>
                        {!basket.time.second_price
                          ? sepMoney(
                            ((basket.time.boxofficeprice - basket.time.price) * basket.count)  // سود  بزرگسال
                            +
                            // سود  خردسال
                            (basket.timeOption.needchild && basket.timeOption.needchild == "true"
                              ? (basket.time.boxofficechildprice - basket.time.childprice) * basket.childcount
                              : 0
                            )
                          )
                          : sepMoney(
                            ((basket.time.boxofficeprice - basket.time.second_price) * basket.count)  // سود  بزرگسال
                            +
                            // سود  خردسال
                            (basket.timeOption.needchild && basket.timeOption.needchild == "true"
                              ? (basket.time.boxofficechildprice - basket.time.second_child_price) * basket.childcount
                              : 0
                            )
                          )
                        }
                        <span className="ms-2">تومان</span>
                      </h6>
                    </div>
                  }
                  {/* قیمت قابل پرداخت  */}
                  <div className="d-flex flex-wrap justify-content-between align-items-center text-white mb-3">
                    <h6 className="white-space-nowrap">مبلغ قابل پرداخت : </h6>
                    {!basket.time.second_price
                      ? <h6>
                        {sepMoney(
                          (basket.time.price * basket.count)  // قیمت نهایی بزرگسال
                          +
                          (basket.timeOption.needchild && basket.timeOption.needchild == "true"
                            ? basket.time.childprice * basket.childcount // قیمت نهایی خردسال
                            : 0
                          )
                          +
                          // قیمت توپ
                          (basket?.reqball ? +basket.time.ballprice : 0)
                          -
                          (kind == "wallet" ? balance == "loading" ? 0 : balance : 0)
                          , true
                        )}

                        <span className="ms-2">تومان</span>
                      </h6>
                      : <h6>
                        {sepMoney(
                          (basket.time.second_price * basket.count)  // قیمت نهایی بزرگسال
                          +
                          (basket.timeOption.needchild && basket.timeOption.needchild == "true"
                            ? basket.time.second_child_price * basket.childcount // قیمت نهایی خردسال
                            : 0
                          )
                          +
                          // قیمت توپ
                          (basket?.reqball ? +basket.time.ballprice : 0)
                          -
                          (kind == "wallet" ? balance == "loading" ? 0 : balance : 0)
                          , true
                        )}

                        <span className="ms-2">تومان</span>
                      </h6>
                    }
                  </div>
                </>
            }

            {/* اینپوت و ثبت کد تخفیف */}
            <div className="offCodeBox my-4">
              <input
                onChange={({ target: { value } }) => {
                  setCode(value);
                }}
                placeholder={"در صورتی که کد تخفیف دارید وارد کنید"}
              />
              <button
                onClick={() => {
                  checkOffer(code);
                }}
              >
                اعمال
                <br />
                <span className="d-lg-none d-xl-inline"> کد تخفیف</span>
              </button>
            </div>

            <p className="mb-2 text-white">
              روش پرداخت
            </p>
            <div className="mb-2 text-white" style={{ fontWeight: "300" }}>
              <div className={"d-flex align-items-center justify-content-between mb-2 " + (kind == "wallet" && "offPay")}>
                <span>
                  <BsCreditCard2Back size={22} className="me-2" />
                  پرداخت آنلاین
                </span>
                <span>
                  {!kind == "wallet" &&
                    <BsCheck2Circle size={22} />
                  }
                </span>
              </div>

              <div className="d-flex align-items-center justify-content-between">
                <span>
                  <BsWallet2 size={22} className="me-2" />
                  استفاده از اعتبار

                  <p className="ms-2" style={{ fontSize: "14px", fontWeight: "300", color: "#f3f3f3" }}>
                    موجودی :

                    {balance == "loading"
                      ?
                      "در حال دریافت ..."
                      :
                      <>
                        <span className="ms-1">
                          {
                            sepMoney(balance)
                          }
                        </span>
                        <span className="ms-1">تومان</span>
                      </>
                    }
                  </p>
                </span>
                <span>
                  <FormGroup>
                    <FormControlLabel size="sm" control={<Switch defaultChecked />} checked={kind == "wallet"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setKind("wallet");
                        }
                        else {
                          setKind("gateway");
                        }
                      }} />
                  </FormGroup>

                </span>
              </div>
            </div>

            <div className="d-flex justify-content-center align-items-center mb-3 mb-xl-2 mt-2 mt-lg-2">
              <button
                style={{
                  border: "none",
                  borderRadius: "0.5rem",
                  backgroundColor: "#fff",
                  padding: "10px 0",
                }}
                className="w-100"
                onClick={() => storeReserve(kind)}
                disabled={loading.reserve}
              >
                {/* {renderState()} */}
                پرداخت
              </button>
            </div>

          </InSetBoxShadow>
        </div>
      </div >

      <CustomModal
        header={"قوانین و مقررات"}
        show={showModal}
        handleClose={() => {
          setShowModal(false);
        }}
      >
        <RulesSite isApp={true} />
      </CustomModal>

    </>
  );
};

export default OrderDetails;